import { render, staticRenderFns } from "./bookable-educator-card.vue?vue&type=template&id=77370cc9&scoped=true&"
import script from "./bookable-educator-card.vue?vue&type=script&lang=js&"
export * from "./bookable-educator-card.vue?vue&type=script&lang=js&"
import style0 from "@/styles/candidate/candidate-card.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./bookable-educator-card.vue?vue&type=style&index=1&id=77370cc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77370cc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VIcon,VLazy,VSkeletonLoader})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
